var cilFullscreenExit = ["512 512", "<polygon fill='var(--ci-primary-color, currentColor)' points='204 181.372 38.628 16 16 16 16 38.628 181.372 204 44 204 44 236 236 236 236 44 204 44 204 181.372' class='ci-primary'/><polygon fill='var(--ci-primary-color, currentColor)' points='326.628 304 464 304 464 272 272 272 272 464 304 464 304 326.628 473.372 496 496 496 496 473.372 326.628 304' class='ci-primary'/>"];

export { cilFullscreenExit };

